<template>
  <div class="main_text_instruction">
    <p><slot /></p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.main_text_instruction {
  display: flex;
  align-items: center;
  //width: calc(50% - 11px);
  box-sizing: border-box;
  gap: 15px;
  border-radius: 11px;
  background: var(--block-color);
  padding: 20px;
  p {
    display: flex;
    align-items: center;
    gap: 10px;
    height: fit-content;
    font-family: "Gilroy";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 23px;
    color: var(--text-second-color);
  }
}
@media screen and (max-width: 700px) {
  .main_text_instruction {
    width: 100%;
    p {
      font-size: 14px;
    }
  }
}
@media screen and (max-width: 460px) {
  .main_text_instruction {
    padding: 10px;
    width: 100%;
    p {
      align-items: flex-start;
      line-height: 150%;
      font-size: 12px;
    }
  }
}
</style>
